body #schedule-popover {
    z-index: 1280;
}
